import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView, useWindowDimensions } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { GeoComplyError } from '@/feature/betslip-sbk/types';
import { showScrollIndicator } from '@/utils/constants-platform-specific';
import { getGeoComplyErrorMessage } from '@/utils/get-geocomply-error-message';

const HEADER_FOOTER_HEIGHT = 275;

export const useGeocomplyErrorProps = () => {
    const { t } = useTranslation();
    const { height } = useWindowDimensions();
    const safeInsets = useSafeAreaInsets();
    const maxContainerHeight = height - safeInsets.top - HEADER_FOOTER_HEIGHT;

    const getGeocomplyErrorProps = useCallback(
        (error: GeoComplyError) => {
            const errorMessage = getGeoComplyErrorMessage(error.payload) || t('error_subtitle');
            return {
                title: t('location_failure'),
                description: (
                    <Box maxHeight={maxContainerHeight}>
                        <ScrollView showsVerticalScrollIndicator={showScrollIndicator}>
                            <Text color={ds.colorToken.text.secondary} textAlign="center" variant="bodyMedium">
                                {errorMessage}
                            </Text>
                        </ScrollView>
                    </Box>
                ),
            };
        },
        [t, maxContainerHeight]
    );

    return {
        getGeocomplyErrorProps,
    };
};
